import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components';

import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedin, FaXTwitter } from 'react-icons/fa6';



const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="box-container">
        
          {/* Event Information & Social Media Links */}
          <div className="footer-item">

            {/* Event Logo */}
            <Logo />

            {/* Event Description */}
            <p>Join the ultimate event experience, bringing industry leaders and enthusiasts together for knowledge, networking, and innovation. Stay connected and updated for the latest event happenings.</p>

            {/* Social Media Links */}
            <div className="social">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaXTwitter /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaLinkedin /></a>
            </div>

            {/* Newsletter component to subscribe */}
            <Newsletter variant='dark' idPrefix='2' />

          </div>

          {/* Quick Links */}
          <div className="footer-item">
            <h2>Quick Links</h2>
            <div className="links">
              <p><Link to="/about">About Us</Link></p>
              <p><Link to="/tickets">Tickets</Link></p>
              <p><Link to="/speakers">Speakers</Link></p>
              <p><Link to="/schedule">Schedule</Link></p>
              <p><Link to="/blog">Blogs</Link></p>
              <p><Link to="/contact">Contact Us</Link></p>
            </div>
          </div>

        </div>
      </div>

      {/* Footer Copyright */}
      <div className="content">
        <p>Designed By AS_Designs | All Rights Reserved</p>
      </div>

    </footer>
  );
};

export default Footer;